module.exports = __webpack_public_path__ + "img/slider-fastvaluedeal.92978051.webp";